<template>
    <main-content-wrapper v-if="authenticated">
        <h1>
            Izbira tipa dokumenta
            <span>ob prejemu naročila</span>
        </h1>
        <v-layout justify-center row fill-height>
            <v-flex xs12 md5 class="elevation-11 login" pl-5 pr-5 pt-4 pb-4 mr-3>
                <template v-if="error_msg!=null">
                    <v-alert
                            :value="true"
                            type="error"
                    >
                        {{ error_msg }}
                    </v-alert>
                    <empty-space />
                </template>
                <v-form v-model="valid" @submit.prevent="" ref="form">
                    <input-field :value="authenticated_user.email" label="Uporabniško ime (oz. e-naslov)" v-on:keypress.enter="login" autofocus prepend-inner-icon="fa-envelope" disabled readonly />
                    <password-field value="TUŠ Cash&Carry" label="Geslo" v-on:keypress.enter="login" :rules="passwordRules" required disabled readonly />
                    <p>Ob prejemu naročila želim dokument:
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-icon size="15" color="primary" v-on="on">fas fa-question-circle</v-icon>
                            </template>
                            <span>Z izbiro boste določili kakšen dokument sem vam pripravi ob prejemu naročila.</span>
                        </v-tooltip>
                    </p>
                    <order-document v-model="document" />
                </v-form>
                <v-btn depressed large block color="primary_action" @click="updateSessionData" :loading="loading">POTRDI IZBIRO</v-btn>
            </v-flex>
        </v-layout>
    </main-content-wrapper>
</template>

<script>
    import MainContentWrapper from "../components/MainContentWrapper";
    import PasswordField from "../components/PasswordField";
    import EmailField from "../components/EmailField";
    import InputField from "../components/InputField";
    import OrderDocument from "../components/OrderDocument";
    import utils from "../store/utils";
    import {userService} from "../services";

    export default {
        name: "SelectDocumentType",
        components: {MainContentWrapper, PasswordField, EmailField, InputField, OrderDocument},
        data: vm => ({
            email: null,
            document: 1,
            loading: false,
            error_msg: null
        }),
        computed: {
            authenticated: utils.vuexBuildSetGet(this, null, 'auth.authenticated'),
            authenticated_user: utils.vuexBuildSetGet(this, null, 'auth.authenticated_user')
        },
        methods: {

            updateSessionData(){
                let isValid = this.$refs.form.validate();
                if (isValid) {
                    this.loading = true;
                    userService.updateSessionData(this.document).then(
                        data => {
                            if (data.redirect){
                                window.location.replace(data.redirect);
                            } else {
                                this.$router.push('/racun');
                            }
                        },
                        error => {
                            this.error_msg = error.message;
                        }
                    ).then(()=>{
                        this.loading = false;
                    });
                }
            }

        }
    }
</script>

<style scoped>

</style>